// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== BASE STYLES (DARK THEME) ==================== */
.employee-container {
  padding: 24px;
  background: #020617; /* Deep Dark Navy */
  min-height: 100vh;
  color: #e5e7eb;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* ==================== HEADER & FILTERS ==================== */
.header-bar {
  margin-bottom: 24px;
}

.filters-row {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  background: #0f172a; 
  padding: 16px 20px;
  border-radius: 16px;
  border: 1px solid #1e293b;
}

.filter-input {
  flex: 1 1;
  min-width: 200px;
  padding: 12px 16px;
  border: 1px solid #1e293b;
  border-radius: 12px;
  font-size: 14px;
  background: #020617;
  color: #e5e7eb;
  transition: all 0.2s;
  outline: none;
}

.filter-input::placeholder {
  color: #64748b;
}

.filter-input:focus {
  border-color: #facc15;
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);
}

/* ==================== ADD BUTTON ==================== */
.add-btn {
  background: #facc15; /* Neon Yellow */
  color: #020617;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
  white-space: nowrap;
}

.add-btn:hover {
  background: #fde047;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(250, 204, 21, 0.3);
}

.add-btn svg {
  width: 18px;
  height: 18px;
}

/* ==================== TABLE STYLES ==================== */
.employee-table {
  width: 100%;
  border-collapse: collapse;
  background: #0f172a;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #1e293b;
  margin-top: 4px;
}

.employee-table thead {
  background: #1e293b;
  border-bottom: 1px solid #334155;
}

.employee-table th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #94a3b8;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.employee-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #1e293b;
  color: #e5e7eb;
  font-size: 14px;
}

.employee-table tbody tr {
  transition: background 0.15s;
}

.employee-table tbody tr:hover {
  background: #1e293b;
}

.employee-table tbody tr:last-child td {
  border-bottom: none;
}

/* ==================== STATUS BADGES ==================== */
.active {
  color: #166534;
  font-weight: 600;
  background:radial-gradient(circle at top, #0f172a, #020617);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  display: inline-block;
}

.inactive {
  color: #991b1b;
  font-weight: 600;
  background: #fee2e2;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  display: inline-block;
}

/* ==================== ACTION BUTTONS (BANKLIST STYLE) ==================== */
.action-icons {
  display: flex;
  gap: 8px;
}

/* ICON BUTTON FIX 🔥 */
.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1e293b;
  border: none;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
}

/* ICON COLOR FIX */
.icon-btn svg {
  color: #fff !important;
  width: 16px;
  height: 16px;
}

/* Hover */
.icon-btn:hover {
  background: #334155;
}

/* Delete Button */
.icon-btn.delete {
  background: #7f1d1d;
}

.icon-btn.delete:hover {
  background: #991b1b;
}

/* ==================== MODAL OVERLAY ==================== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(2, 6, 23, 0.85);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* ==================== MODAL BOX ==================== */
.modal-box {
  background: #0f172a;
  padding: 32px;
  border-radius: 18px;
  max-width: 950px;
  width: 95%;
  max-height: 90vh;
  overflow-y: auto;
  border: 1px solid #1e293b;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.8);
  animation: slideUp 0.3s ease;
  color: #e5e7eb;
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.modal-box h2 {
  margin: 0 0 20px 0;
  color: #f8fafc;
  font-size: 24px;
  font-weight: 600;
  border-bottom: 1px solid #1e293b;
  padding-bottom: 16px;
}

/* ==================== VIEW MODAL DETAILS GRID ==================== */
.detail-row {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid #1e293b;
}

.detail-row:last-of-type {
  border-bottom: none;
}

.detail-label {
  min-width: 120px;
  font-weight: 600;
  color: #94a3b8;
  flex-shrink: 0;
}

.detail-value {
  color: #f8fafc;
  flex: 1 1;
  word-break: break-word;
}

/* ==================== FORM GROUPS ==================== */
.form-group {
  margin-bottom: 24px;
}

.form-group label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #cbd5e1;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #1e293b;
  border-radius: 12px;
  font-size: 14px;
  transition: all 0.2s;
  background: #020617;
  color: #e5e7eb;
  outline: none;
}

.form-group input:focus {
  border-color: #facc15;
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);
}

/* ==================== CKEDITOR WRAPPER ==================== */
.ckeditor-wrapper {
  border: 1px solid #1e293b;
  border-radius: 12px;
  overflow: hidden;
  background: #020617;
}

.ckeditor-wrapper .ck.ck-editor__editable_inline {
  background: #020617 !important;
  color: #e5e7eb !important;
  min-height: 400px;
  max-height: 500px;
  padding: 20px;
}

.ckeditor-wrapper .ck.ck-editor__editable_inline p {
  margin: 10px 0;
  line-height: 1.8;
  color: #cbd5e1 !important;
}

.ckeditor-wrapper .ck.ck-editor__editable_inline h2 {
  margin: 20px 0 15px;
  font-size: 22px;
  color: #f8fafc !important;
}

.ckeditor-wrapper .ck.ck-editor__editable_inline h3 {
  margin: 18px 0 12px;
  font-size: 18px;
  color: #e2e8f0 !important;
  border-bottom: 1px solid #334155;
  padding-bottom: 8px;
}

.ckeditor-wrapper .ck.ck-editor__editable_inline ul,
.ckeditor-wrapper .ck.ck-editor__editable_inline ol {
  padding-left: 25px;
  margin: 10px 0;
}

.ckeditor-wrapper .ck.ck-editor__editable_inline li {
  margin: 6px 0;
  line-height: 1.8;
  color: #cbd5e1 !important;
}

.ckeditor-wrapper .ck.ck-editor__editable_inline strong {
  color: #f8fafc !important;
}

.ck.ck-toolbar {
  background: #1e293b !important;
  border-color: #1e293b !important;
}
.ck.ck-toolbar .ck-button {
  color: #e5e7eb !important;
}
.ck.ck-toolbar .ck-button:hover {
  background: #334155 !important;
}

/* ==================== TERMS CONTENT BOX ==================== */
.form-group .content-label {
  margin-top: 10px;
  margin-bottom: 12px;
  display: block;
  font-weight: 600;
  color: #94a3b8;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.terms-content-box {
  max-height: 400px;
  overflow-y: auto;
  padding: 20px;
  border: 1px solid #1e293b;
  background: #020617;
  border-radius: 12px;
  line-height: 1.8;
  color: #cbd5e1;
}

.terms-content-box h2 {
  color: #f8fafc;
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 22px;
}

.terms-content-box h3 {
  color: #e2e8f0;
  margin-top: 25px;
  margin-bottom: 12px;
  font-size: 18px;
  border-bottom: 1px solid #334155;
  padding-bottom: 8px;
}

.terms-content-box p {
  margin: 12px 0;
  line-height: 1.8;
}

.terms-content-box ul,
.terms-content-box ol {
  padding-left: 25px;
  margin: 12px 0;
}

.terms-content-box li {
  margin: 8px 0;
  line-height: 1.8;
}

.terms-content-box strong {
  font-weight: 600;
  color: #f8fafc;
}

.terms-content-box hr {
  margin: 30px 0;
  border: none;
  border-top: 2px solid #1e293b;
}

/* ==================== MODAL ACTIONS ==================== */
.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #1e293b;
}

.btn-close {
  padding: 10px 24px;
  background: transparent;
  border: 1px solid #334155;
  color: #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-close:hover {
  background: #020617;
}

.btn-save {
  padding: 10px 24px;
  background: #facc15;
  color: #020617;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
}

.btn-save:hover {
  background: #fde047;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 768px) {
  .employee-container { padding: 12px; }
  .filters-row { flex-direction: column; align-items: stretch; }
  .employee-table { font-size: 13px; display: block; overflow-x: auto; white-space: nowrap; }
  .modal-box { padding: 20px; }
  .detail-row { flex-direction: column; gap: 4px; }
  .detail-label { min-width: unset; font-size: 12px; }
}
@media (max-width: 576px) {
  .employee-table { font-size: 12px; }
  .icon-btn { padding: 4px; }
  .icon-btn svg { width: 14px; height: 14px; }
}`, "",{"version":3,"sources":["webpack://./src/pages/TermCondition/TermPage.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB,EAAE,mBAAmB;EACxC,iBAAiB;EACjB,cAAc;EACd,8EAA8E;AAChF;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,yDAAyD;AACzD;EACE,mBAAmB,EAAE,gBAAgB;EACrC,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,gBAAgB;EAChB,2DAA2D;EAC3D,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;EAC1C,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,+DAA+D;AAC/D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,sBAAsB,aAAa,EAAE;EACrC,eAAe,sBAAsB,EAAE,oBAAoB,EAAE;EAC7D,kBAAkB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;EAC1F,aAAa,aAAa,EAAE;EAC5B,cAAc,sBAAsB,EAAE,QAAQ,EAAE;EAChD,gBAAgB,gBAAgB,EAAE,eAAe,EAAE;AACrD;AACA;EACE,kBAAkB,eAAe,EAAE;EACnC,YAAY,YAAY,EAAE;EAC1B,gBAAgB,WAAW,EAAE,YAAY,EAAE;AAC7C","sourcesContent":["/* ==================== BASE STYLES (DARK THEME) ==================== */\n.employee-container {\n  padding: 24px;\n  background: #020617; /* Deep Dark Navy */\n  min-height: 100vh;\n  color: #e5e7eb;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* ==================== HEADER & FILTERS ==================== */\n.header-bar {\n  margin-bottom: 24px;\n}\n\n.filters-row {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  background: #0f172a; \n  padding: 16px 20px;\n  border-radius: 16px;\n  border: 1px solid #1e293b;\n}\n\n.filter-input {\n  flex: 1;\n  min-width: 200px;\n  padding: 12px 16px;\n  border: 1px solid #1e293b;\n  border-radius: 12px;\n  font-size: 14px;\n  background: #020617;\n  color: #e5e7eb;\n  transition: all 0.2s;\n  outline: none;\n}\n\n.filter-input::placeholder {\n  color: #64748b;\n}\n\n.filter-input:focus {\n  border-color: #facc15;\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);\n}\n\n/* ==================== ADD BUTTON ==================== */\n.add-btn {\n  background: #facc15; /* Neon Yellow */\n  color: #020617;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.add-btn:hover {\n  background: #fde047;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(250, 204, 21, 0.3);\n}\n\n.add-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* ==================== TABLE STYLES ==================== */\n.employee-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #0f172a;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid #1e293b;\n  margin-top: 4px;\n}\n\n.employee-table thead {\n  background: #1e293b;\n  border-bottom: 1px solid #334155;\n}\n\n.employee-table th {\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #94a3b8;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.employee-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #1e293b;\n  color: #e5e7eb;\n  font-size: 14px;\n}\n\n.employee-table tbody tr {\n  transition: background 0.15s;\n}\n\n.employee-table tbody tr:hover {\n  background: #1e293b;\n}\n\n.employee-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* ==================== STATUS BADGES ==================== */\n.active {\n  color: #166534;\n  font-weight: 600;\n  background:radial-gradient(circle at top, #0f172a, #020617);\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  display: inline-block;\n}\n\n.inactive {\n  color: #991b1b;\n  font-weight: 600;\n  background: #fee2e2;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  display: inline-block;\n}\n\n/* ==================== ACTION BUTTONS (BANKLIST STYLE) ==================== */\n.action-icons {\n  display: flex;\n  gap: 8px;\n}\n\n/* ICON BUTTON FIX 🔥 */\n.icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #1e293b;\n  border: none;\n  padding: 6px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n/* ICON COLOR FIX */\n.icon-btn svg {\n  color: #fff !important;\n  width: 16px;\n  height: 16px;\n}\n\n/* Hover */\n.icon-btn:hover {\n  background: #334155;\n}\n\n/* Delete Button */\n.icon-btn.delete {\n  background: #7f1d1d;\n}\n\n.icon-btn.delete:hover {\n  background: #991b1b;\n}\n\n/* ==================== MODAL OVERLAY ==================== */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(2, 6, 23, 0.85);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* ==================== MODAL BOX ==================== */\n.modal-box {\n  background: #0f172a;\n  padding: 32px;\n  border-radius: 18px;\n  max-width: 950px;\n  width: 95%;\n  max-height: 90vh;\n  overflow-y: auto;\n  border: 1px solid #1e293b;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.8);\n  animation: slideUp 0.3s ease;\n  color: #e5e7eb;\n}\n\n@keyframes slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.modal-box h2 {\n  margin: 0 0 20px 0;\n  color: #f8fafc;\n  font-size: 24px;\n  font-weight: 600;\n  border-bottom: 1px solid #1e293b;\n  padding-bottom: 16px;\n}\n\n/* ==================== VIEW MODAL DETAILS GRID ==================== */\n.detail-row {\n  display: flex;\n  align-items: flex-start;\n  padding: 10px 0;\n  border-bottom: 1px solid #1e293b;\n}\n\n.detail-row:last-of-type {\n  border-bottom: none;\n}\n\n.detail-label {\n  min-width: 120px;\n  font-weight: 600;\n  color: #94a3b8;\n  flex-shrink: 0;\n}\n\n.detail-value {\n  color: #f8fafc;\n  flex: 1;\n  word-break: break-word;\n}\n\n/* ==================== FORM GROUPS ==================== */\n.form-group {\n  margin-bottom: 24px;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #cbd5e1;\n  font-size: 14px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid #1e293b;\n  border-radius: 12px;\n  font-size: 14px;\n  transition: all 0.2s;\n  background: #020617;\n  color: #e5e7eb;\n  outline: none;\n}\n\n.form-group input:focus {\n  border-color: #facc15;\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);\n}\n\n/* ==================== CKEDITOR WRAPPER ==================== */\n.ckeditor-wrapper {\n  border: 1px solid #1e293b;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #020617;\n}\n\n.ckeditor-wrapper .ck.ck-editor__editable_inline {\n  background: #020617 !important;\n  color: #e5e7eb !important;\n  min-height: 400px;\n  max-height: 500px;\n  padding: 20px;\n}\n\n.ckeditor-wrapper .ck.ck-editor__editable_inline p {\n  margin: 10px 0;\n  line-height: 1.8;\n  color: #cbd5e1 !important;\n}\n\n.ckeditor-wrapper .ck.ck-editor__editable_inline h2 {\n  margin: 20px 0 15px;\n  font-size: 22px;\n  color: #f8fafc !important;\n}\n\n.ckeditor-wrapper .ck.ck-editor__editable_inline h3 {\n  margin: 18px 0 12px;\n  font-size: 18px;\n  color: #e2e8f0 !important;\n  border-bottom: 1px solid #334155;\n  padding-bottom: 8px;\n}\n\n.ckeditor-wrapper .ck.ck-editor__editable_inline ul,\n.ckeditor-wrapper .ck.ck-editor__editable_inline ol {\n  padding-left: 25px;\n  margin: 10px 0;\n}\n\n.ckeditor-wrapper .ck.ck-editor__editable_inline li {\n  margin: 6px 0;\n  line-height: 1.8;\n  color: #cbd5e1 !important;\n}\n\n.ckeditor-wrapper .ck.ck-editor__editable_inline strong {\n  color: #f8fafc !important;\n}\n\n.ck.ck-toolbar {\n  background: #1e293b !important;\n  border-color: #1e293b !important;\n}\n.ck.ck-toolbar .ck-button {\n  color: #e5e7eb !important;\n}\n.ck.ck-toolbar .ck-button:hover {\n  background: #334155 !important;\n}\n\n/* ==================== TERMS CONTENT BOX ==================== */\n.form-group .content-label {\n  margin-top: 10px;\n  margin-bottom: 12px;\n  display: block;\n  font-weight: 600;\n  color: #94a3b8;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n}\n\n.terms-content-box {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 20px;\n  border: 1px solid #1e293b;\n  background: #020617;\n  border-radius: 12px;\n  line-height: 1.8;\n  color: #cbd5e1;\n}\n\n.terms-content-box h2 {\n  color: #f8fafc;\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: 22px;\n}\n\n.terms-content-box h3 {\n  color: #e2e8f0;\n  margin-top: 25px;\n  margin-bottom: 12px;\n  font-size: 18px;\n  border-bottom: 1px solid #334155;\n  padding-bottom: 8px;\n}\n\n.terms-content-box p {\n  margin: 12px 0;\n  line-height: 1.8;\n}\n\n.terms-content-box ul,\n.terms-content-box ol {\n  padding-left: 25px;\n  margin: 12px 0;\n}\n\n.terms-content-box li {\n  margin: 8px 0;\n  line-height: 1.8;\n}\n\n.terms-content-box strong {\n  font-weight: 600;\n  color: #f8fafc;\n}\n\n.terms-content-box hr {\n  margin: 30px 0;\n  border: none;\n  border-top: 2px solid #1e293b;\n}\n\n/* ==================== MODAL ACTIONS ==================== */\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #1e293b;\n}\n\n.btn-close {\n  padding: 10px 24px;\n  background: transparent;\n  border: 1px solid #334155;\n  color: #e5e7eb;\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.btn-close:hover {\n  background: #020617;\n}\n\n.btn-save {\n  padding: 10px 24px;\n  background: #facc15;\n  color: #020617;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.btn-save:hover {\n  background: #fde047;\n}\n\n/* ==================== RESPONSIVE ==================== */\n@media (max-width: 768px) {\n  .employee-container { padding: 12px; }\n  .filters-row { flex-direction: column; align-items: stretch; }\n  .employee-table { font-size: 13px; display: block; overflow-x: auto; white-space: nowrap; }\n  .modal-box { padding: 20px; }\n  .detail-row { flex-direction: column; gap: 4px; }\n  .detail-label { min-width: unset; font-size: 12px; }\n}\n@media (max-width: 576px) {\n  .employee-table { font-size: 12px; }\n  .icon-btn { padding: 4px; }\n  .icon-btn svg { width: 14px; height: 14px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
